var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLossOfRent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4307",
    "data-name": "Group 4307",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39.53,
    height: 41.565,
    viewBox: "0 0 39.53 41.565",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2574",
    "data-name": "Rectangle 2574",
    width: 39.53,
    height: 41.565,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4306",
    "data-name": "Group 4306",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50908",
    "data-name": "Path 50908",
    d: "M28.76,37.512H4.053V1.663h26.7V18.036C31,18.02,31.25,18,31.509,18c.313,0,.612.021.91.044V.831A.831.831,0,0,0,31.588,0H3.222a.831.831,0,0,0-.831.831V38.343a.832.832,0,0,0,.831.832H31.588a.832.832,0,0,0,.831-.832v-.831Z",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50909",
    "data-name": "Path 50909",
    d: "M29.2,39.9H1.663V3.221A.832.832,0,0,0,0,3.221V40.733a.832.832,0,0,0,.831.832H29.2a.831.831,0,0,0,0-1.663",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50910",
    "data-name": "Path 50910",
    d: "M19.846,24.537a.832.832,0,0,0-.832-.831H13.608a.831.831,0,0,0,0,1.662h5.406a.832.832,0,0,0,.832-.831",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50911",
    "data-name": "Path 50911",
    d: "M7.3,29.344H9.664a.832.832,0,0,0,0-1.663H7.3a.832.832,0,0,0,0,1.663",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50912",
    "data-name": "Path 50912",
    d: "M12.208,29.344h8.355a.832.832,0,0,0,0-1.663H12.208a.832.832,0,0,0,0,1.663",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50913",
    "data-name": "Path 50913",
    d: "M7.3,33.32h13.4a.832.832,0,0,0,0-1.663H7.3a.832.832,0,0,0,0,1.663",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50914",
    "data-name": "Path 50914",
    d: "M10.632,16.9a.832.832,0,0,0,0,1.663H24.515a.832.832,0,1,0,0-1.663h-.56V12.307a.829.829,0,0,0,1.147-1.2L22.74,8.747V5.953a.831.831,0,1,0-1.662,0V7.085l-2.73-2.73a1.1,1.1,0,0,0-1.549,0L10.044,11.11a.83.83,0,0,0,1.149,1.2V16.9Zm2.224-6.25,4.717-4.718,3.748,3.747h0l.969.97V16.9H18.406V12.52a.832.832,0,1,0-1.663,0V16.9H12.856Z",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50915",
    "data-name": "Path 50915",
    d: "M31.125,36.41a8.4,8.4,0,1,1,8.4-8.4,8.414,8.414,0,0,1-8.4,8.4m0-15.174a6.77,6.77,0,1,0,6.77,6.77,6.778,6.778,0,0,0-6.77-6.77",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50916",
    "data-name": "Path 50916",
    d: "M27.806,23.423h6.645a.6.6,0,0,1,0,1.2H32.49a3.4,3.4,0,0,1,.642,1.5h1.319a.6.6,0,0,1,0,1.2H33.132a3.13,3.13,0,0,1-3.223,2.7h-.486l2.963,2.535a.6.6,0,0,1-.775.906l-4.16-3.558a.6.6,0,0,1,.355-1.079h2.1a1.946,1.946,0,0,0,2-1.5H27.806a.6.6,0,0,1,0-1.2h4.106a1.942,1.942,0,0,0-1.98-1.5H27.806a.6.6,0,0,1,0-1.2",
    fill: "#3d3d3d",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLossOfRent);
export default __webpack_public_path__ + "static/media/loss-of-rent.aa9020668ee8921c447580f4b8f07968.svg";
export { ForwardRef as ReactComponent };